import {BaseService} from "@/core/services/BaseService";
import {buildFormData, generatorQueryString} from "@/core/helpers/functions";

class ClaimService extends BaseService<any> {
  endpoint = '/claim'

  async updateStatus(id, body) {
    return await this.http().put(this.endpoint + "/" + id + "/status", body).then(res => {
      return res.data
    })
  }

  async moveClaim(id: any, value) {
    return this.http().put(this.endpoint + "/" + id + "/move", value).then(res => {
      return res.data
    })
  }

  async emailFormat(id, data) {
    return this.http().post(this.endpoint + "/" + id + "/email/format", data).then(res => {
      return res.data
    })
  }

  async sendAck(id, data, files) {
    const formData = buildFormData(data);
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }
    return this.uploadHttp().post(this.endpoint + "/" + id + "/email/ack", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => {
      return res.data
    })
  }

  async updateDoc(id, data) {
    return await this.http().put(this.endpoint + "/" + id + "/doc-status", data).then(res => {
      return res.data;
    })
  }

  async updateClaimDoc(id, data) {
    return await this.http().put(this.endpoint + "/" + id + "/doc-claim-status", data).then(res => {
      return res.data;
    })
  }

  async updateDecision(id, data) {
    return await this.http().put(this.endpoint + "/" + id + "/decision", data).then(res => {
      return res.data;
    })
  }

  async updateApproval(id, data) {
    return await this.http().put(this.endpoint + "/" + id + "/approval", data).then(res => {
      return res.data;
    })
  }

  async reserveOutstanding(id) {
    return await this.http().get(this.endpoint + "/" + id + "/outstanding-reserve").then(res => {
      return res.data;
    })
  }

  async fastTrack(filter) {
    const queryString = generatorQueryString(filter);
    return this.http().get<any>(this.endpoint + "/fast-track?" + queryString).then(res => {
      return res.data
    })
  }

  async scan(id) {
    return this.http().get(this.endpoint + "/" + id + "/scan").then(res => {
      return res.data;
    })
  }

  async secureLink(id) {
    return this.http().get(this.endpoint + "/" + id + "/secure-link").then(res => {
      return res.data
    })
  }

  async updateGhipDetail(id, data) {
    return this.http().put(this.endpoint + "/" + id + "/ghip-detail", data).then(res => {
      return res.data
    })
  }

  async updateGhipStatus(claimId: string, model: any) {
    return this.http().put(this.endpoint + "/" + claimId + "/ghip-status", model).then(res => {
      return res.data
    })
  }

  async updateCOBStatus(claimId: string, model: any) {
    return this.http().put(this.endpoint + "/" + claimId + "/cob-status", model).then(res => {
      return res.data
    })
  }

  async checkGhipComplete(id) {
    return this.http().get(this.endpoint + "/" + id + "/check-ghip-complete").then(res => {
      return res.data
    })
  }

  async setReserve(id, data) {
    return this.http().post(this.endpoint + "/" + id + "/set-reserve", data).then(res => {
      return res.data
    })
  }

  async setExaminer(id, exId) {
    return this.http().post(this.endpoint + "/" + id + "/set-examiner/" + exId).then(res => {
      return res.data
    })
  }

  async sendConfirmCoverage(id, data) {
    return this.http().post(this.endpoint + "/" + id + "/confirm-coverage", data).then(res => {
      return res.data
    })
  }

  async sendRequestDocuments(id, data) {
    return this.http().post(this.endpoint + "/" + id + "/request-documents", data).then(res => {
      return res.data
    })
  }

  async hasOtherClaim(id) {
    return this.http().get(this.endpoint + "/" + id + "/has-other").then(res => {
      return res.data
    })
  }

  async getDocumentRequestLink(id, lang) {
    return this.http().get(this.endpoint + "/" + id + "/link-request-documents/" + lang).then(res => {
      return res.data
    })
  }

  async getOtherInsurance(id) {
    return this.http().get(this.endpoint + "/" + id + "/recoveries").then(res => {
      return res.data
    })
  }

  async askClaudia(id: number, data: { prompt: string }) {
    return this.http().post(`/ask-claudia/claim/${id}`, data).then(res => {
      return res.data
    })
  }


  async getClaimForms(id: any) {
    return this.http().get(this.endpoint + "/" + id + "/claim-forms").then(res => {
      return res.data
    })
  }

}

export default new ClaimService();